export function isTestRideHeroSectionEmpty(props) {
    return !props.labels || !props.backgroundImage;
}
